let activeInCart = [];
// Shipping and minimum order amounts
let freeShippingThreshold = window.siteWideSettings.freeShippingThreshold;
const gwpDollarThreshold = window.siteWideSettings.gwpDollarThreshold;
let gwpThreshold;
let gwpVariantId;

if(gwpDollarThreshold == true) {
  gwpThreshold = window.siteWideSettings.gwpThreshold;
  gwpVariantId = window.siteWideSettings.gwpVariantId;   
}

(function (window, document) {
  "use strict";
  var AgileCart = function (options) {
    var defaults = {
      // Defaults configuration
      cartTrigger: ".js-go-cart-trigger",
      cartHeaderTotal: ".header-cart__total",
      cartDrawer: ".js-go-cart-drawer",
      cartDrawerContent: ".js-go-cart-drawer-content",
      cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
      cartDrawerFooter: ".js-go-cart-drawer-footer",
      cartDrawerClose: ".js-go-cart-drawer-close",
      cartRemoveAll: ".cart-drawer__remove-all",
      cartPageContent: ".cart__items--wrapper",
      cartTotalWrapper: ".cart-totals-wrapper",
      cartOverlay: ".js-go-cart-overlay",
      cartCount: ".js-go-cart-counter",
      addToCart: ".js-go-cart-add-to-cart",
      addToCartSearch: ".quick-add__submit-search",
      removeFromCart: ".go-cart-item__remove",
      itemQuantity: ".js-go-cart-quantity",
      itemQuantityPlus: ".js-go-cart-quantity-plus",
      itemQuantityMinus: ".js-go-cart-quantity-minus",
      cartCollection: ".go-cart__collection",
      shippingThresholdTextWrapper: ".threshold__text",
      numberElement: ".cart-shipping__num",
      freeShippingProgress: ".cart-shipping__numOuter",
      cartSuccessMessage: ".cart-shipping__success",
      cartProgressBar: ".cart-shippingThreshold__progress",
      cartShippingWrapper: ".cart-shipping__wrapper",
      cartShippingDisclaimer: ".cart-reserve__wrapper",
      liquorContainer: ".liquor-check-age",
      minSpendWrapper: ".min-cart-spend",
      moneyFormat: "${{amount}}",
    };

    this.settings = Object.assign({}, defaults, options);
    this.init();
    this.bindEvents();
  };

  AgileCart.prototype.init = function () {
    this.cartTrigger = document.querySelector(this.settings.cartTrigger);
    this.cartHeaderTotal = document.querySelector(this.settings.cartHeaderTotal);
    this.cartDrawer = document.querySelector(this.settings.cartDrawer);
    this.cartDrawerContent = document.querySelector(this.settings.cartDrawerContent);
    this.cartDrawerSubTotal = document.querySelector(this.settings.cartDrawerSubTotal);
    this.cartDrawerFooter = document.querySelector(this.settings.cartDrawerFooter);
    this.cartDrawerClose = document.querySelector(this.settings.cartDrawerClose);
    this.cartPageContent = document.querySelector(this.settings.cartPageContent);
    this.cartTotalWrapper = document.querySelector(this.settings.cartTotalWrapper);
    this.cartOverlay = document.querySelector(this.settings.cartOverlay);
    this.cartCount = document.querySelector(this.settings.cartCount);
    this.addToCart = document.querySelector(this.settings.addToCart);
    this.addToCartSearch = document.querySelector(this.settings.addToCartSearch);
    this.removeFromCart = document.querySelector(this.settings.removeFromCart);
    this.itemQuantity = document.querySelector(this.settings.itemQuantity);
    this.itemQuantityPlus = document.querySelector(this.settings.itemQuantityPlus);
    this.itemQuantityMinus = document.querySelector(this.settings.itemQuantityMinus);
    this.cartCollection = document.querySelector(this.settings.cartCollection);
    this.shippingThresholdTextWrapper = document.querySelectorAll(this.settings.shippingThresholdTextWrapper);
    this.numberElement = document.querySelectorAll(this.settings.numberElement);
    this.freeShippingProgress = document.querySelectorAll(this.settings.freeShippingProgress);
    this.cartSuccessMessage = document.querySelector(this.settings.cartSuccessMessage);
    this.cartProgressBar = document.querySelectorAll(this.settings.cartProgressBar);
    this.cartShippingWrapper = document.querySelector(this.settings.cartShippingWrapper);
    this.cartShippingDisclaimer = document.querySelector(this.settings.cartShippingDisclaimer);
    this.minSpendWrapper = document.querySelectorAll(this.settings.minSpendWrapper);
    this.liquorContainer = document.querySelector(this.settings.liquorContainer);
    this.fetchCart();
  };

  AgileCart.prototype.bindEvents = function () {
    var self = this;

    this.cartTrigger.addEventListener("click", function () {
      document.body.classList.add("overflow-hidden");
      self.fetchCart();
      self.openCartOverlay();
    });

    this.cartOverlay.addEventListener("click", function () {
      document.body.classList.remove("overflow-hidden");
      self.closeCartOverlay();
    });

    this.cartDrawerClose.addEventListener("click", function () {
      document.body.classList.remove("overflow-hidden");
      self.closeCartOverlay();
    });

    document.addEventListener("click", function (event) {
      if (event.target.matches(self.settings.cartRemoveAll)) {
        if (confirm("Are you sure?")) {
          self.removeAll();
          if (isCartTemplate) {
            self.cartPageContent.classList.add("updating-cart");
          } else {
            self.cartDrawerContent.classList.add("updating-cart");
          }
          self.renderBlankCartDrawer();
        }
      }
    });

  

    document.addEventListener("click", function (event) {
  if (event.target.matches(self.settings.addToCart)) {
    event.preventDefault();
    self.cartDrawerContent.classList.add("updating-cart");

    var formElement = event.target.closest("form");
    var variantInput = formElement.querySelector('input[name="id"]');
    
    if (!variantInput || !variantInput.value) {
      console.error('Could not find variant ID');
      return;
    }
    
    var variantId = variantInput.value;
    
    // Check for selected add-on with ID
    const selectedAddOn = document.querySelector('.addon-option[addon-selected][data-product-id]');
    
    if (selectedAddOn) {
      // Create array for multiple items
      const addOnProducts = [
        { id: parseInt(variantId), quantity: 1 },
        { id: parseInt(selectedAddOn.dataset.productId), quantity: 1 }
      ];
      
      // Use addItemsToCart for main product + add-on
      self.addItemsToCart(addOnProducts);
    } else {
      // No selected add-on with ID, use regular addItemToCart
      self.addItemToCart(formElement.getAttribute('id'));  // Use getAttribute('id') instead of .id
    }

    // Remove the 'show-quick-view' class from the body
    document.body.classList.remove('show-quick-view');
    
    // Find any open quickview popups and remove the 'open-qv-popup' class
    document.querySelectorAll('.quickview-popup.open-qv-popup').forEach(popup => {
      popup.classList.remove('open-qv-popup');
    });
  }
}, false);
         

    document.addEventListener("click",function (event) {
        if (event.target.matches(self.settings.removeFromCart)) {
          if(event.target.matches('.bundle-remove')) {
            self.cartDrawerContent.classList.add("updating-cart");
            var bundleKeys = event.target.getAttribute('data-bundle-keys'); // Assuming bundleID is stored in a data attribute
            self.removeItemsByKeys(bundleKeys);
          } else {
            self.cartDrawerContent.classList.add("updating-cart");
            var lineItemElement = event.target.closest(".go-cart-item__single");
            var lineNumber = lineItemElement.getAttribute("data-line");
            self.removeItem(lineNumber);
          }
        }
    }, false);

    document.addEventListener("click", function (event) {
        if (event.target.matches(self.settings.itemQuantityPlus)) {
            self.cartDrawerContent.classList.add("updating-cart");
            var itemElement = event.target.closest(".go-cart-item__single");
            let maxQuantity = parseInt(itemElement.querySelector(self.settings.itemQuantity).max);
            var line = itemElement.getAttribute("data-line");
            var currentQuantity = parseInt(itemElement.querySelector(self.settings.itemQuantity).value, 10);
            if (isNaN(currentQuantity) || currentQuantity < maxQuantity) {
              self.changeItemQuantity(line, currentQuantity + 1);
            } else {
              console.error("Maximum quantity reached");
              itemElement.querySelector(".product-error__container").innerHTML = "Maximum quantity in cart";

              setTimeout(function () {
                itemElement.querySelector(".product-error__container").innerHTML = "";
              }, 2000);
            }
          }
        

        if (event.target.matches(self.settings.itemQuantityMinus)) {
            self.cartDrawerContent.classList.add("updating-cart");
            var itemElement = event.target.closest(".go-cart-item__single");
            var line = itemElement.getAttribute("data-line");
            var currentQuantity = parseInt(itemElement.querySelector(self.settings.itemQuantity).value,10);
            // Check if currentQuantity is greater than 1
            if (currentQuantity > 1) {
              self.changeItemQuantity(line, currentQuantity - 1);
            } else {
              self.removeItem(line);
            }
        }
      }, false);

    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
  };

  (AgileCart.prototype.fetchCart = function () {
    console.log("fetchCart");
    let self = this;
    let productsInCartArray = [];
    let currentCartValue = 0;
    let cartItemTotal = 0;
    let gwpToAdd = [];
    window.fetch("/cart.js", { credentials: "same-origin", method: "GET" })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        
        currentCartValue = cart.total_price;
        cartItemTotal = cart.item_count;

        cart.items.forEach((item) => {
          const {
            title: itemTitle,
            variant_id: itemId,
            quantity: itemQuantity,
            price: itemPrice,
            product_type: itemType, 
          } = item;

          productsInCartArray.push({ id: itemId, quantity: itemQuantity });
        });

        // Check if gwpVariantId exists in the productsInCartArray
        var isGwpInCart = productsInCartArray.some(function(product) {
          return product.id === gwpVariantId;
        });

        self.fetchHandler(cart, cartItemTotal, currentCartValue);
        self.freeShippingCalculator(currentCartValue);
        
        console.log(gwpDollarThreshold + ' ' + currentCartValue + ' ' + gwpThreshold + ' ' + isGwpInCart)
        
        if(gwpDollarThreshold == true && currentCartValue > gwpThreshold && !isGwpInCart) { 
          gwpToAdd.push({
           id: gwpVariantId,
           quantity: 1});
           self.addItemsToCart(gwpToAdd);
        }
        
        //self.cartHeaderTotal.innerHTML = self.formatMoney(currentCartValue,self.moneyFormat);
      })
      .catch(function (response) {
        console.error("Error while fetching the cart:", response);
      });
    }),

    (AgileCart.prototype.formatMoney = function (amount) {
      console.log("formatMoney");
      return this.settings.moneyFormat.replace("{{amount}}", amount);
    });

    (AgileCart.prototype.fetchHandler = function (cart, cartItemTotal, currentCartValue) {
      this.cartItemCount(cartItemTotal);
      if (cart.item_count === 0) {
        this.renderBlankCartDrawer();
      } else {
        //this.cartCollection.classList.add("is-invisible");
        this.renderDrawerCart(cart, currentCartValue);
        this.cartDrawerFooter.classList.remove("is-invisible");
      }
    }),
      
    (AgileCart.prototype.cartItemCount = function (cartItemTotal) {
      this.cartCount.innerHTML = cartItemTotal;
    }),
      
    (AgileCart.prototype.addItemToCart = function (formId) {
      console.log("addItemToCart");
      var self = this,
      formElement = document.querySelector("#" + formId); // Correctly target the form by its ID

      if (!formElement) {
        console.error("Form not found: #" + formId);
        return; // Exit if form not found
      }

     // Create FormData object from the form
     var formData = new FormData(formElement);
     console.log(formData);

     // Convert FormData to URL-encoded string
     var formDataObj = new URLSearchParams();
     formData.forEach(function (value, key) {
       formDataObj.append(key, value);
     });

     console.log(formDataObj.toString());

     window.fetch("/cart/add.js", {
         method: "POST",
         credentials: "include",
         headers: { "Content-Type": "application/x-www-form-urlencoded" },
         body: formDataObj.toString(), // Use the URL-encoded string
       })
       .then(function (response) {
         return response.json();
       })
       .then(function (cartResponse) {
         self.openCartOverlay();
         self.fetchCart(); // Handle cart count update
       })
       .catch(function (error) {
         self.ajaxRequestFail(); // Make sure this method is defined to handle request failures
         console.error("Error adding item to cart: ", error);
       });
    });

   AgileCart.prototype.addItemsToCart = function (itemsArray) {
  console.log("addItemsToCart");
  var self = this;

  // Create an array to hold the line items
  var items = [];

  // Loop through each item in the array
  itemsArray.forEach(function (item) {
    var lineItem = {
      id: item.id,
      quantity: item.quantity,
      properties: item.properties
    };

    // Add this line item to the items array
    items.push(lineItem);
  });

  // Prepare the data for the POST request
  const data = {
    items: items
  };

  console.log("Data to send:", data);

  // Make a single fetch request to add all items in one call
  window.fetch("/cart/add.js", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(data), // Use JSON format to send multiple line items
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (cartResponse) {
      console.log("All items added to cart:", cartResponse);
      self.openCartOverlay();
      self.fetchCart(); // Fetch the updated cart after all items are added
    })
    .catch(function (error) {
      self.ajaxRequestFail(); // Handle request failures
      console.error("Error adding items to cart: ", error);
    });
};

  
    (AgileCart.prototype.addItemToCartSearch = function (wrapperId) {
      var self = this;

      // Find the hidden input within the wrapper
      var variantId = wrapperId;
      console.log(variantId);

      if (!variantId) {
        console.error("Variant ID input not found");
        return; // Exit if the variant input is not found
      }

      // Create an object to submit. Adjust the object structure as per your needs.
      var formDataObj = { id: variantId };

      window.fetch("/cart/add.js", {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formDataObj), // Use the object directly
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cartResponse) {
          self.fetchCart(); // Handle cart count update
        })
        .catch(function (error) {
          self.ajaxRequestFail(); // Make sure this method is defined to handle request failures
          console.error("Error adding item to cart: ", error);
        });
    });

    (AgileCart.prototype.changeItemQuantity = function (lineNumber, quantity) {
      console.log("changeItemQuantity");
      var self = this;
      window.fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify({ quantity: quantity, line: lineNumber }),
        headers: { "Content-Type": "application/json" },
      })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        return self.fetchCart();
      })
      .catch(function (error) {
        self.ajaxRequestFail();
        console.error(error);
      });
    });
  
    AgileCart.prototype.updateItemQuantity = function (productUpdates) {
  console.log("updateItemQuantity");
  var self = this;

  const data = {
    updates: {},
    properties: {}
  };

  // Loop through each product update and populate the data object
  productUpdates.forEach((update) => {
    const { id, quantity } = update;
    
    // Set quantity for the product
    data.updates[id] = quantity;

  });

  // Set up the request options for the Fetch API
  const options = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  };

  // Set up the URL for the Ajax API call
  const apiUrl = "/cart/update.js";

  // Make the API call using the Fetch API
  fetch(apiUrl, options)
    .then((response) => response.json())
    .then((data) => console.log(data))
    .catch((error) => console.error(error))
    .finally(() => {
      self.openCartOverlay();
      self.fetchCart();
    });
};
  
    (AgileCart.prototype.removeItem = function (lineNumber) {
      console.log("removeItem");
      var self = this;
      window
        .fetch("/cart/change.js", {
          method: "POST",
          credentials: "same-origin",
          body: JSON.stringify({ quantity: 0, line: lineNumber }),
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          return self.fetchCart();
        })
        .catch(function (error) {
          self.ajaxRequestFail();
          console.error(error); // Log the error instead of throwing it
        });
    });

    (AgileCart.prototype.removeItemsByKeys = function (keys) {
  var self = this;

  // Split the keys into an array, as they are comma-separated
  const keyArray = keys.split(',').filter(Boolean); // Filter out any empty strings

  // Log keys for debugging purposes
  console.log('Keys to remove:', keyArray);

  // Create an object to hold the updates
  const updates = {};

  // Loop through each key in the array and set quantity to 0
  keyArray.forEach(function (key) {
    if (key && key.length > 0) { // Make sure it's not an empty string
      console.log('Adding item to remove with id:', key); // Log each id before removal
      updates[key.trim()] = 0; // Set quantity to 0 for this id
    } else {
      console.error('Invalid id encountered:', key);
    }
  });

  // Log the full update payload for debugging
  console.log('Sending batch remove request with updates:', updates);

  // Make a single fetch request to batch remove the items
  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      updates: updates // Send the entire updates object in one request
    })
  })
  .then(function (response) {
    if (!response.ok) {
      console.error('Failed to remove items, Response:', response);
      throw new Error('Failed to remove items');
    }
    return response.json();
  })
  .then(function (data) {
    console.log('Items successfully removed:', data);
    self.fetchCart(); // Fetch the updated cart after all items are removed
  })
  .catch(function (error) {
    console.error('Error removing items:', error);
  });
});
  
    (AgileCart.prototype.removeAll = function () {
      console.log("removeAll");
      var self = this;
      window
        .fetch("/cart/clear.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          return self.fetchCart();
        })
        .catch(function (error) {
          self.ajaxRequestFail();
          console.error(error); // Log the error instead of throwing it
        });
    });
 
    // Utility methods
    (AgileCart.prototype.openCartOverlay = function () {
      this.settings.cartDrawer.classList.add("is-open");
      this.settings.cartOverlay.classList.add("is-open");
    });

    (AgileCart.prototype.closeCartOverlay = function () {
      document.body.classList.remove("overflow-hidden");
      this.settings.cartDrawer.classList.remove("is-open");
      this.settings.cartOverlay.classList.remove("is-open");
    });

    (AgileCart.prototype.renderBlankCartDrawer = function () {
      console.log("renderBlankDrawer");
      this.cartDrawerContent.classList.add("empty-cart");
      //this.cartShippingDisclaimer.classList.add("is-invisible");
      //this.cartCollection.classList.remove("is-invisible");
      this.cartDrawerFooter.classList.add("is-invisible");
      this.cartDrawerSubTotal.parentNode.classList.add("is-invisible");
      this.cartShippingWrapper.classList.add("is-invisible");
      //this.clearCart();
      this.cartDrawerContent.innerHTML = `
            <div class="go-cart__empty">
               <svg class="icon icon-cart" role="presentation" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                 <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                 <line x1="3" y1="6" x2="21" y2="6"></line>
                 <path d="M16 10a4 4 0 0 1-8 0"></path>
              </svg>
              Your cart is empty
              <a href="/collections/scents" class="button button-solid">Continue Shopping</a>
            </div>
           `;
    });

    (AgileCart.prototype.renderBlankCartPage = function () {
      console.log("renderBlankPage");
      var cartItems = document.querySelector(".cart__items");
      document.querySelector(".cart-totals-wrapper").style.display = "none";
      if (cartItems) {
        document.querySelector(".cart__items").style.display = "none";
      }
      document.querySelector(".cart__warnings").style.display = "flex";
      this.clearCart();
    });

    (AgileCart.prototype.renderDrawerCart = function (cart, currentCartValue) {
      var emptyCartElement = this.cartDrawerContent.querySelector(".go-cart__empty");
      
      // Check if the element exists before trying to remove it
      if (emptyCartElement) {
        emptyCartElement.remove();
      }
      this.cartDrawerContent.classList.remove("empty-cart");
      this.cartShippingWrapper.classList.remove("is-invisible");
      var self = this;

      console.log("renderDrawerCart");

      // Show the overlay
      // Start simulating progress
      const progressBar = document.querySelector(".progress-bar-inner");
      if(progressBar) {
        progressBar.style.width = "0%"; // Reset progress
        setTimeout(() => (progressBar.style.width = "100%"), 100); // Start progress
      }

      fetch("/?section_id=cart-drawer-items", {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
        },
      })
        .then((response) => response.text())
        .then((html) => {
          // Inject the new HTML into the cart drawer
          self.cartDrawerContent.innerHTML = html;

          self.cartDrawerContent.classList.remove("updating-cart");
          if(progressBar) {
            progressBar.style.width = "0%"; // Reset progress bar for the next update
          }

          self.cartDrawerSubTotal.innerHTML = self.formatMoney(
            currentCartValue,
            self.moneyFormat
          );
          self.cartDrawerSubTotal.parentNode.classList.remove("is-invisible");
        })
        .catch((error) => console.error("Error updating cart drawer:", error));
    });

    (AgileCart.prototype.renderCartPage = function (cart) {
    
      var self = this;
      let updatedCartPrice = 0;
      console.log("renderCartPage");

      const progressBar = document.querySelector(".progress-bar");
      progressBar.style.width = "0%"; // Reset progress
      setTimeout(() => (progressBar.style.width = "100%"), 100); // Start progress

      fetch("/?section_id=cart-page-items", {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
        },
      })
      .then((response) => response.text())
      .then((html) => {
        // Inject the new HTML into the cart drawer
        self.cartPageContent.innerHTML = html;

        self.cartPageContent.classList.remove("updating-cart");
        progressBar.style.width = "0%"; // Reset progress bar for the next update
        self.updateCartSubtotal();
        self.cartHeaderTotal.innerHTML = self.formatMoney(
          cart.total_price,
          self.moneyFormat
        );
        const liquorAgeCheck = document.querySelector(".liquor-check-age");
        if (hasLiquor) {
          liquorAgeCheck.classList.add("show-liquor-age-check");
        } else {
          liquorAgeCheck.classList.remove("show-liquor-age-check");
        }
      })
      .catch((error) => console.error("Error updating cart drawer:", error));
    });

    (AgileCart.prototype.updateCartSubtotal = function () {
      console.log("updateCartSubtotal");
      var self = this;

      fetch("/?section_id=cart-totals")
        .then((response) => response.text())
        .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const checkoutElement = doc.getElementById("checkout");

        // Inject the modified HTML into the totals wrapper
        document.querySelector(".totals-wrapper").innerHTML = doc.body.innerHTML;
      })
      .catch((error) => console.error("Error updating cart subtotal:", error));
    });

    (AgileCart.prototype.openCartOverlay = function () {
       this.cartDrawer.classList.add("is-open");
      this.cartOverlay.classList.add("is-open");
    });

    (AgileCart.prototype.closeCartOverlay = function () {
      this.cartDrawer.classList.remove("is-open");
      this.cartOverlay.classList.remove("is-open");
    });

    (AgileCart.prototype.removeItemAnimation = function (element) {
      if (element) element.classList.add("is-invisible");
    });

    (AgileCart.prototype.clearCart = function () {
      console.log("clearCart");
      this.cartDrawerContent.innerHTML = "";
    });

    // Free Shipping Calculator
    (AgileCart.prototype.freeShippingCalculator = function (currentCartValue) {
      var self = this;
      console.log("freeShippingCalculator");

      console.log("freeShippingThreshold:", freeShippingThreshold);

      var percentage;
      var newProgressNum;

      if (currentCartValue < freeShippingThreshold) {
        percentage = (currentCartValue / freeShippingThreshold) * 100;
      
        newProgressNum = currentCartValue;

        console.log("Initial newProgressNum:", newProgressNum);

        newProgressNum = (freeShippingThreshold - newProgressNum) / 100;

        console.log("After calculation:", newProgressNum);

        newProgressNum = newProgressNum.toFixed(2);
        console.log("Final newProgressNum:", newProgressNum); 

        self.shippingThresholdTextWrapper.forEach(function (el) {
          el.innerHTML = " & receive FREE SHIPPING.";
        });

        self.numberElement.forEach(function (el) {
          el.textContent = "$" + newProgressNum;
        });

        self.freeShippingProgress.forEach(function (el) {
          el.style.display = "block";
        });

        self.cartSuccessMessage.style.display = "none";

        self.cartProgressBar.forEach(function (el) {
          el.setAttribute("style", "width:" + percentage + "%");
        });
      } else {
        newProgressNum = (freeShippingThreshold - currentCartValue) / 100;
        newProgressNum = parseFloat(newProgressNum.toFixed(2));
        percentage = 100;
     
        self.numberElement.forEach(function (el) {
          el.innerHTML = "$" + newProgressNum;
        });

        self.freeShippingProgress.forEach(function (el) {
          el.style.display = "none";
        });

        self.cartSuccessMessage.style.display = "block";

        self.cartProgressBar.forEach(function (el) {
          el.setAttribute("style", "width:100%");
        });
      }
    });


    (AgileCart.prototype.formatMoney = function (cents, format) {
      console.log();
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || "${{amount}}";

      function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ",",
        decimal = "."
      ) {
        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          `$1${thousands}`
        );
        const cents = parts[1] ? decimal + parts[1] : "";

        return dollars + cents;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    });

    function fetchJSONP(url, callbackParamName) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        const callbackFunctionName = `jsonp_callback_${Math.round(100000 * Math.random())}`;

        window[callbackFunctionName] = function (data) {
          delete window[callbackFunctionName];
          document.body.removeChild(script);
          resolve(data);
        };

        // Ensure correct URL formatting
        const separator = url.includes("?") ? "&" : "?";
        script.src = `${url}${separator}${callbackParamName}=${callbackFunctionName}`;
        script.onerror = function () {
          delete window[callbackFunctionName];
          document.body.removeChild(script);
          reject(new Error("Script load error"));
        };
        document.body.appendChild(script);
      });
    }
    // Make sure to implement ajaxRequestFail as needed

    window.AgileCart = AgileCart;
})(window, document);

var agileCart = new AgileCart({});